import { create } from 'zustand';

export const useDestinations = create((set, get) => ({
  // starredNodes keeps a list of integers which map to a node.id
  destinations: [],
  setDestinations: (destinations) => {
    set((state) => ({
      destinations: destinations,
    }));
  },
}));
